import { ListChecks } from 'lucide-react';

import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'award-categories',
    label: 'Award Categories',
    description: 'The kinds of award, and the documents each one asks of a nominee.',
    icon: ListChecks,
    to: '/praise/settings/award-categories',
    permission: 'award-categories.read',
  },
];

/**
 * PRAISE → Settings: a menu of what the module configures. A row added here owes its key to the
 * route's `anyOf` and the sidebar entry's `anyPermission` in the same change.
 */
export function PraiseSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Human Resources', 'PRAISE', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-y-auto overflow-x-hidden p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            What the Program on Awards and Incentives for Service Excellence draws on. Every award is opened under a
            category and asks each nominee for that category&apos;s documents, so a category needs at least one document on
            its checklist before an award can be opened under it.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
